import { Tooltip } from "antd";
import { CopyOutlined } from "@ant-design/icons";

export const CopyIconButton = ({ text }: { text?: string }) => {
  return (
    <Tooltip title="已複製" trigger="click">
      <CopyOutlined
        onClick={async () => {
          text && (await navigator.clipboard.writeText(text));
        }}
      />
    </Tooltip>
  );
};
